import React from 'react'

import { InnerListItem } from '../../atoms'

type Props = { items: string[] }

export const InnerList = ({ items }: Props) => {
  return (
    <>
      {items.map((item, index) => (
        <InnerListItem key={index}>{item}</InnerListItem>
      ))}
    </>
  )
}
